import 'twin.macro';
import React from 'react';
import { Checkboxes } from '@teetsh/app/src/components/Form/Checkboxes';
import {
  Filter,
  FilterNumberValue,
} from '@teetsh/app/src/containers/Eleves/List/Table/FilterBar/types';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import NumberInputGroup from 'components/Form/NumberInputGroup';

interface Props {
  filter: Filter;
  onChange: (v: string[] | boolean | FilterNumberValue) => void;
}

export function FilterOptions(props: Props) {
  const { t } = useTranslation(['common', 'eleve']);
  const { filter, onChange } = props;
  const [min, max]: FilterNumberValue =
    filter.fieldType === 'number' ? filter.filterValue : ['', ''];

  if (filter.fieldType === 'bool') {
    return (
      <div tw="flex items-center space-x-4">
        {[
          { label: 'Oui', value: true },
          { label: 'Non', value: false },
        ].map(({ label, value }) => (
          <Button
            key={label}
            active={filter.filterValue === value}
            onClick={() => onChange(value)}
          >
            {label}
          </Button>
        ))}
      </div>
    );
  }
  if (filter.fieldType === 'select' || filter.fieldType === 'multiselect') {
    if ((filter.options || []).length === 0) {
      return <div>{t('eleve:noElementToFilter')}</div>;
    }
    return (
      <Checkboxes<string>
        value={filter.filterValue}
        onChange={r => onChange(r)}
        options={filter.options}
      />
    );
  }
  if (filter.fieldType === 'number') {
    return (
      <div tw="flex items-end space-x-4">
        <NumberInputGroup
          label="Min"
          withoutMargin
          emptyValue=""
          min={-99999}
          max={99999}
          fractionDigits={2}
          value={min === 0 ? 0 : min || undefined}
          onChange={val => {
            const newMinMax: FilterNumberValue = [val ?? '', max];
            onChange(newMinMax);
          }}
        />
        <span tw="text-muted text-sm mb-3">{t('common:filters.to')}</span>
        <NumberInputGroup
          label="Max"
          withoutMargin
          emptyValue=""
          min={-99999}
          max={99999}
          fractionDigits={2}
          value={max === 0 ? 0 : max || undefined}
          onChange={val => {
            const newMinMax: FilterNumberValue = [min, val ?? ''];
            onChange(newMinMax);
          }}
        />
      </div>
    );
  }
  return null;
}
